import physicalWorldOrders from './service-orders'
import terminals from './terminals'

export default {
  physicalWorldOrders,
  terminals
}
